var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.92563 7.50003L12.5 7.50003C12.6419 7.50003 12.7607 7.54789 12.8564 7.64361C12.9521 7.73934 13 7.85814 13 8.00001C13 8.14189 12.9521 8.26069 12.8564 8.35641C12.7607 8.45214 12.6419 8.5 12.5 8.5H4.92563L7.12053 10.6949C7.21968 10.794 7.26861 10.9101 7.26732 11.043C7.26604 11.1759 7.21711 11.294 7.12053 11.3974C7.01711 11.5009 6.89831 11.5543 6.76413 11.5577C6.62994 11.5611 6.51114 11.5111 6.40773 11.4077L3.42183 8.4218C3.35945 8.35941 3.31543 8.2936 3.28978 8.22436C3.26414 8.15514 3.25132 8.08036 3.25132 8.00001C3.25132 7.91967 3.26414 7.84489 3.28978 7.77566C3.31543 7.70643 3.35945 7.64062 3.42183 7.57823L6.40773 4.59233C6.50687 4.49319 6.62459 4.44425 6.76092 4.44553C6.89724 4.44682 7.01711 4.49917 7.12053 4.60258C7.21711 4.706 7.26711 4.8231 7.27053 4.95386C7.27394 5.08463 7.22394 5.20172 7.12053 5.30513L4.92563 7.50003Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftAlt);
export default __webpack_public_path__ + "static/media/arrow_left_alt.2dc40a7029112cc5541b45dd612966b9.svg";
export { ForwardRef as ReactComponent };